<!--
 * @Author: your name
 * @Date: 2021-04-08 22:02:30
 * @LastEditTime: 2023-02-05 21:12:21
 * @LastEditors: yanglq-PC 61739363@qq.com
 * @Description: In User Settings Edit
 * @FilePath: \web_page\src\page\GoodList.vue
-->
<template>
    <div class="layout">
        <MainHeader />
        <UserNav />
        <div class="main_box">
            <el-main>
                <UserNavList />
                <div class="user_box">
                    <el-breadcrumb separator-class="el-icon-arrow-right"
                                   class="breadvrumb_box">
                        <el-breadcrumb-item :to="`/Center`">
                            首頁
                        </el-breadcrumb-item>
                        <el-breadcrumb-item>訂單信息</el-breadcrumb-item>
                    </el-breadcrumb>
                    <div class="order_div">
                        <el-tabs v-model="activeName">
                            <el-tab-pane label="未付款"
                                         name="first">
                                <div class="table_box">
                                    <el-table ref="multipleTable"
                                              v-loading="order_loading"
                                              :data="order_list_1"
                                              tooltip-effect="dark"
                                              style="width: 100%">
                                        <el-table-column prop="order_num"
                                                         label="訂單號"
                                                         width="200">
                                        </el-table-column>
                                        <el-table-column prop="num"
                                                         label="總數量"
                                                         width="90">
                                        </el-table-column>
                                        <el-table-column prop="price"
                                                         label="總金額"
                                                         width="120">
                                            <template slot-scope="scope">
                                                <span>{{ amountFormatte(scope.row.price) }}</span>
                                            </template>
                                        </el-table-column>
                                        <el-table-column prop="address"
                                                         label="郵寄地址">
                                        </el-table-column>

                                        <el-table-column label="操作"
                                                         width="100">
                                            <template slot-scope="scope">
                                                <el-button size="mini"
                                                           type="primary"
                                                           @click="showDialogTable(scope.row.id, scope.row)">
                                                    查看詳情
                                                </el-button>
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                    <div class="page_box">
                                        <el-pagination background
                                                       :page-size="page_num"
                                                       layout="prev, pager, next"
                                                       :total="all_num_1"
                                                       @current-change="handleCurrentChange_1">
                                        </el-pagination>
                                    </div>
                                </div>
                            </el-tab-pane>
                            <el-tab-pane label="已付款"
                                         name="second">
                                <div class="table_box">
                                    <el-table ref="multipleTable"
                                              v-loading="order_loading"
                                              :data="order_list_2"
                                              tooltip-effect="dark"
                                              style="width: 100%">
                                        <el-table-column prop="order_num"
                                                         label="訂單號"
                                                         width="190">
                                        </el-table-column>
                                        <el-table-column prop="num"
                                                         label="總數量"
                                                         width="90">
                                        </el-table-column>
                                        <el-table-column prop="price"
                                                         label="總金額"
                                                         width="120">
                                            <template slot-scope="scope">
                                                <span>{{ amountFormatte(scope.row.price) }}</span>
                                            </template>
                                        </el-table-column>
                                        <el-table-column prop="postage"
                                                         label="郵費"
                                                         width="90">
                                            <template slot-scope="scope">
                                                <span>{{ amountFormatte(scope.row.postage) }}</span>
                                            </template>
                                        </el-table-column>
                                        <el-table-column prop="weight"
                                                         label="郵寄重量"
                                                         width="90">
                                        </el-table-column>
                                        <el-table-column prop="address"
                                                         label="郵寄地址">
                                        </el-table-column>

                                        <el-table-column label="操作"
                                                         width="100">
                                            <template slot-scope="scope">
                                                <el-button size="mini"
                                                           type="primary"
                                                           @click="showDialogTable(scope.row.id, scope.row)">
                                                    查看詳情
                                                </el-button>
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                    <div class="page_box">
                                        <el-pagination background
                                                       :page-size="page_num"
                                                       layout="prev, pager, next"
                                                       :total="all_num_2"
                                                       @current-change="handleCurrentChange_2">
                                        </el-pagination>
                                    </div>
                                </div>
                            </el-tab-pane>
                        </el-tabs>
                    </div>
                </div>
                <el-dialog title="訂單詳情"
                           width="1000px"
                           :visible.sync="dialogTableVisible">
                    <div class="dialog_order_info">
                        <div class="info_item">
                            <span>商品金額：</span>{{ amountFormatte(order_info.price) }}
                        </div>
                        <div class="info_item">
                            <span>訂單郵費：</span>{{ amountFormatte(order_info.postage) }}
                        </div>
                        <div class="info_item">
                            <span>總數量：</span>{{ order_info.num }} 件
                        </div>
                        <div class="info_item">
                            <span>總重量：</span>{{ Number(order_info.weight).toFixed(2) }} KG
                        </div>
                        <div class="info_item">
                            <span>合計：</span>{{ amountFormatte(Number(order_info.price) + Number(order_info.postage)) }}
                        </div>
                    </div>
                    <el-table v-loading="dialog_Loading"
                              :data="order_goods"
                              tooltip-effect="dark">
                        <el-table-column label="商品名稱">
                            <template slot-scope="scope">
                                <img class="goods_img"
                                     :src="scope.row.image">
                                <div class="goods_info_box">
                                    <p class="goods_name">
                                        {{ scope.row.name }}
                                    </p>
                                    <p class="goods_attr">
                                        購買屬性：{{ scope.row.attr }}
                                    </p>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="price"
                                         label="單價"
                                         width="120">
                            <template slot-scope="scope">
                                <span>{{ amountFormatte(scope.row.price) }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="weight"
                                         label="重量(KG)"
                                         width="100">
                        </el-table-column>
                        <el-table-column prop="num"
                                         label="數量"
                                         width="100">
                        </el-table-column>
                        <el-table-column label="總金額"
                                         width="120">
                            <template slot-scope="scope">
                                {{ amountFormatte(scope.row.price*scope.row.num) }}
                            </template>
                        </el-table-column>
                    </el-table>
                </el-dialog>
            </el-main>
        </div>
        <MainFooter />
    </div>
</template>

<script>
import MainHeader from "@/components/Header";
import UserNav from "@/components/UserNav";
import UserNavList from "@/components/UserNavList";
import MainFooter from "@/components/Footer";
import { getOrderList, getOrderGoods } from "@/api/goodsAPI";
import { changeImage, amountFormatte } from "@/utils";
export default {
    components: {
        MainHeader,
        UserNav,
        MainFooter,
        UserNavList,
    },
    data() {
        return {
            activeName: "first", // 显示的tab名称
            order_list_1: [], // 未付款订单列表
            order_list_2: [], // 已付款订单列表
            all_num_1: 0, // 未付款订单总数量
            all_num_2: 0, // 已付款订单总数量
            page_1: 1, // 未付款订单页码
            page_2: 1, // 已付款订单页码
            page_num: 10, // 每页条数
            dialogTableVisible: false, // 是否显示弹窗
            order_goods: [], // 订单商品
            order_info: [], // 订单详情
            dialog_Loading: false, // 订单详情表格加载
            order_loading: false, // 订单列表表格加载
        };
    },
    computed: {},
    created() {
        this.getListData(1, 1);
        this.getListData(2, 1);
    },
    methods: {
        amountFormatte,
        // 获取订单列表页
        async getListData(status, page) {
            this.order_loading = true;
            var resp = await getOrderList(status, page, this.page_num);
            switch (status) {
                case 1:
                    this.order_list_1 = resp.order_list;
                    this.all_num_1 = resp.all_num;
                    break;
                case 2:
                    this.order_list_2 = resp.order_list;
                    this.all_num_2 = resp.all_num;
                    break;
            }
            this.order_loading = false;
        },
        // 未付款翻页
        handleCurrentChange_1(val) {
            this.getListData(1, val);
        },
        // 已付款翻页
        handleCurrentChange_2(val) {
            this.getListData(2, val);
        },
        // 显示弹窗
        showDialogTable(id, order_info) {
            this.getGoodsData(id, order_info);
            this.dialogTableVisible = true;
        },
        // 加载订单商品详情
        async getGoodsData(list_id, order_info) {
            this.dialog_Loading = true;
            var resp = await getOrderGoods(list_id);
            this.order_goods = changeImage(150, 150, resp.goods_list, "thumb");
            // 绑定该订单的信息
            this.order_info = order_info;
            this.dialog_Loading = false;
        },
    },
};
</script>

<style scoped lang="scss">
.main_box {
    background: #f5f6f8 url("../../public/img/user-bg.jpg") center 0 no-repeat;
    min-height: 600px;
    height: auto;
    overflow: hidden;
    .el-main {
        width: 1000px;
        margin: 24px auto;
        padding: 0;
        background-color: rgba(255, 255, 255, 0);
        .user_box {
            float: right;
            width: 820px;
            min-height: 600px;
            _height: 600px;
            margin-bottom: 20px;
            .breadvrumb_box {
                margin: 8px 0 10px 0;
                border-left: 2px solid #ff2832;
                padding-left: 10px;
                height: 16px;
                line-height: 16px;
                ::v-deep .el-breadcrumb__inner.is-link:hover {
                    color: #ff2832;
                }
            }
            .order_div {
                padding: 10px;
                height: auto;
                ::v-deep .el-tabs__item.is-active,
                ::v-deep .el-tabs__item:hover {
                    color: #ff2832;
                }
                ::v-deep .el-tabs__active-bar {
                    background-color: #ff2832;
                }
            }
        }
        .page_box {
            text-align: right;
            margin: 30px 0;
        }
        .goods_img {
            display: block;
            float: left;
            width: 100px;
            max-width: 100px;
            height: 100px;
            padding: 5px;
            border: 1px solid #dedede;
        }
        .goods_info_box {
            max-width: 330px;
            float: left;
            margin-left: 10px;
            .goods_name {
                padding: 10px 0;
                font-weight: bold;
            }
            .goods_attr {
                color: #999;
            }
        }
        .addr_box {
            background-color: #fff;
            padding-bottom: 15px;
            .tit {
                padding: 12px 10px;
            }
            .el-textarea {
                width: 90%;
                margin: 0 auto;
                display: block;
            }
        }
        .dialog_order_info {
            padding: 0 0 25px 15px;
            border-bottom: 1px solid #dedede;
            .info_item {
                margin: 5px 0;
                span {
                    display: inline-block;
                    font-weight: bold;
                    width: 80px;
                }
            }
        }
    }
}
</style>
